module.exports = __webpack_public_path__ + "static/media/ponto_ana.0f9e4363.png";